import { gql } from '@apollo/client';

export const CREATE_ACCESS_POLICY = gql`
    mutation CreateAccessPolicy($name: String!, $description: String, $rules: JSON!) {
        createAccessPolicy(name: $name, description: $description, rules: $rules) {
            id
        }
    }
`;

export const UPDATE_ACCESS_POLICY = gql`
    mutation UpdateAccessPolicy($id: Int!, $name: String, $description: String, $rules: JSON) {
        updateAccessPolicy(id: $id, name: $name, description: $description, rules: $rules) {
            id
        }
    }
`;

export const DELETE_ACCESS_POLICY = gql`
    mutation DeleteAccessPolicy($id: Int!) {
        deleteAccessPolicy(id: $id) {
            id
        }
    }
`;

export const ASSIGN_POLICY_TO_USER = gql`
    mutation AssignPolicyToUser($userId: Int!, $policyId: Int!) {
        assignPolicyToUser(userId: $userId, policyId: $policyId) {
            id
        }
    }
`;

export const UNASSIGN_POLICY_FROM_USER = gql`
    mutation UnassignPolicyFromUser($userId: Int!) {
        unassignPolicyFromUser(userId: $userId) {
            id
        }
    }
`;
